import React, { createContext, useContext, useState, useCallback } from 'react';
import FullscreenGalleryImage from './Fullscreen';

export default function ZoomableGalleryImage({ children }) {
  const [isFullscreen, setIsFullScreen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [templateColor, setTemplateColor] = useState('');

  const handleOpen = useCallback((src, templateColor) => {
    setImageSrc(src);
    setIsFullScreen(true);
    setTemplateColor(templateColor);
  }, []);

  const handleClose = useCallback(() => {
    setIsFullScreen(false);
  }, []);

  return (
    <ZoomableGalleryImageContext.Provider value={{ handleOpen, handleClose }}>
      {children}
      <FullscreenGalleryImage isFullscreen={isFullscreen} templateColor={templateColor} imageSrc={imageSrc} onClose={handleClose} />
    </ZoomableGalleryImageContext.Provider>
  );
}

const ZoomableGalleryImageContext = createContext();
export function useZoomableGalleryImage() {
  const ctx = useContext(ZoomableGalleryImageContext);
  if (!ctx) {
    throw new Error('useZoomableGalleryImage must be used within ZoomableGalleryImageProvider');
  }
  return ctx;
}